export class CustomerParameters {
    public static ESPLORO_ACTIVITIES = 'esploro_activities';
    public static ESPLORO_PROJECTS = 'esploro_projects';
}
